import { AVAILABLE_SPECIAL_CHARACTERS_FOR_PASSWORD } from "@/constants";
import { cn } from "@/lib/utils";

export function PasswordDescription(
  {
    className,
    variant,
  }: { className?: string; variant?: "signup" | "reset" } = {
    variant: "signup",
  },
) {
  // FormDescriptionは<p>なので<div>をネストするとHydration Errorが出る。そこで<span>で囲む
  return (
    <span className={cn("block whitespace-pre-wrap", className)}>
      {"※ 10文字以上で設定してください。\n"}
      {
        "※ 英字の大文字と小文字と数字、記号それぞれ1つ以上を指定してください。\n"
      }
      {`※ 使用可能な記号 ${AVAILABLE_SPECIAL_CHARACTERS_FOR_PASSWORD}`}
      {variant === "reset" &&
        "\n※ 現在のパスワードと同じパスワードは使用できません。"}
    </span>
  );
}
